import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=647b47b6&scoped=true"
import script from "./TransactionDetail.vue?vue&type=script&lang=ts"
export * from "./TransactionDetail.vue?vue&type=script&lang=ts"
import style0 from "./TransactionDetail.vue?vue&type=style&index=0&id=647b47b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b47b6",
  null
  
)

export default component.exports